import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { openDialog } from "../../store/actions";

interface IProps {
  govId: number;
  name: string;
  raceName: string;
}

const GovernorateInfoLink = ({
  govId,
  name,
  raceName
}: IProps) => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useDispatch();

  return (
    <a
      ref={linkRef}
      onClick={event => dispatch(openDialog({
        name: "GovernorateInfo",
        header: name,
        subHeader: "Governorate",
        elementRef: linkRef.current,
        clear: true,
        event,
        checkNotReload: (dialogOptions: any) => dialogOptions.govId === govId,
        govId
      }))}
      className={`link ${raceName}`}
    >
      {name}
    </a>
  )
}

export default GovernorateInfoLink;
